import { styled } from "@mui/material";
import {
  type GridRenderCellParams,
  type GridColDef,
} from "@mui/x-data-grid-pro";
import { DataGrid } from "./DataGrid";
import {
  type ToolbarProps,
  CommercialMonitoringDataGridToolbar,
} from "./CommercialMonitoringDataGridToolbar";
import { useGridPagination } from "../hooks/useGridPagination";
import { type CommercialMonitoringDetailReceptionBookRow } from "../types";
import { format, parseISO } from "date-fns";
import { commercialMonitoringDataGridStyles } from "./commercialMonitoringDataGridStyles";

interface IProps {
  rows: CommercialMonitoringDetailReceptionBookRow[];
}

const StyledDataGrid = styled(DataGrid)`
  ${commercialMonitoringDataGridStyles}
`;

const makeGridColDef = (): GridColDef[] => {
  return [
    {
      field: "legalAffairsBureauRequestDate",
      headerName: "法務局受付日",
      width: 180,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ value }: GridRenderCellParams<string>) => {
        if (value != null) return format(parseISO(value), "yyyy/MM/dd");
      },
    },
    {
      field: "receptionReason",
      headerName: "登記原因",
      width: 200,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
  ];
};

export const CommercialMonitoringDetailReceptionBookDataGrid: React.FC<
  IProps
> = (props: IProps) => {
  const { rows } = props;
  const { page, pageSize, changePage, changePageSize } = useGridPagination();
  const rowsPerPageOptions: number[] = [25, 50, 100];
  const colDef = makeGridColDef();

  const dataGridPaginationProps = {
    page,
    pageSize,
    rowsPerPageOptions,
    onPageChange: changePage,
    onPageSizeChange: changePageSize,
  };

  const toolbarProps: ToolbarProps = {
    page,
    pageSize,
    rowsPerPageOptions,
    changePage,
    changePageSize,
    allCount: rows.length,
  };

  return (
    <StyledDataGrid
      autoHeight
      columns={colDef}
      disableColumnMenu
      disableSelectionOnClick={true}
      rows={rows}
      {...dataGridPaginationProps}
      components={{
        Toolbar: CommercialMonitoringDataGridToolbar,
      }}
      componentsProps={{
        toolbar: {
          ...toolbarProps,
        },
      }}
    />
  );
};
